define('wizard_module.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('wizard_module', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2>Module Name</h2>  ";
},"useData":true}, 'extensions/Tavanoteam/TT_C2C_Master_Theme/1.9.7/', 'extensions/Tavanoteam/TT_C2C_Master_Theme/1.9.7/', Handlebars);
});